import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./layout/Home";
import AIApplication from "./views/services/AIApplication";
import WebApplication from "./views/services/WebApplication";
import MobileApplication from "./views/services/MobileApplication";
import CloudDeployment from "./views/services/CloudDeployment";
import MessageHub from "./views/services/MessageHub";
import Unibuilder from "./views/products/Unibuilder";
import TaskAlarm from "./views/products/TaskAlarm";
import AiBridge from "./views/products/AiBridge";
import KnowledgeGraph from "./views/products/KnowledgeGraph";
import Finance from "./views/industries/Finance";
import Healthcare from "./views/industries/Healthcare";
import Education from "./views/industries/Education";
import Logistics from "./views/industries/Logistics";
import AIProducts from "./views/industries/AIProducts";
import Company from "./views/about/Company";
import Career from "./views/about/Career";
import Contact from "./views/about/Contact";

const MainRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services/ai-applications" element={<AIApplication />} />
      <Route path="/services/web-applications" element={<WebApplication />} />
      <Route path="/services/mobile-applications" element={<MobileApplication />} />
      <Route path="/services/cloud-deployment" element={<CloudDeployment />} />
      <Route path="/services/messagehub" element={<MessageHub />} />
      <Route path="/products/unibuilder" element={<Unibuilder />} />
      <Route path="/products/task-alarm" element={<TaskAlarm />} />
      <Route path="/products/ai-bridge" element={<AiBridge />} />
      <Route path="/products/knowledge-graph" element={<KnowledgeGraph />} />
      <Route path="/industries/finance" element={<Finance />} />
      <Route path="/industries/healthcare" element={<Healthcare />} />
      <Route path="/industries/education" element={<Education />} />
      <Route path="/industries/logistics" element={<Logistics />} />
      <Route path="/industries/ai-products" element={<AIProducts />} />
      <Route path="/about/company" element={<Company />} />
      <Route path="/about/career" element={<Career />} />
      <Route path="/about/contact" element={<Contact />} />
    </Routes>
  );
};

export default MainRouter;
